import { isEmpty, isNotDefined, isNotEmpty, type LocationExchangeUnit, type LocationId } from '@terros/common'

export type IsUnitRequiredInput = {
  units: LocationExchangeUnit[]
  locationId?: LocationId
  /** a unit typed in by users who can edit address details */
  unitNbr?: string
}

/** Without a unit, saving a building whose units we know matches one of them at random */
export function isUnitRequired({ units, locationId, unitNbr }: IsUnitRequiredInput): boolean {
  return isNotEmpty(units) && isNotDefined(locationId) && isEmpty(unitNbr?.trim())
}
